export default __webpack_public_path__ + "static/media/job-application.37aacf34.png";